import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo/square.png';
import circleLogo from '../../assets/logo/circleBlurred.png';
import { BackgroundContainer, LogoContainer, CenterBox, CircleLogo, Title } from './Loading.styles';

const Loading = ({ setLoading }) => {
  const [isVisible, setIsVisible] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    const fadeOutDuration = 1500; // Duration fade-out
    const minLoadingDuration = 2500; //Min duration loading

    const timer = setTimeout(() => {
      setIsVisible(false);
      navigate('/');
    }, minLoadingDuration + fadeOutDuration);

    return () => clearTimeout(timer);
  }, [setLoading, navigate]);

  if (!isVisible) return null;

  return (
    <BackgroundContainer className={isVisible ? '' : 'fade-out'}>
      {/* Logo superior */}
      <LogoContainer>
        <img src={logo} alt="Tempo Logo" style={{ width: '40px', height: '40px' }} />
        <Title>Tempo</Title>
      </LogoContainer>
      <CenterBox>
        <CircleLogo src={circleLogo} alt="Loading Logo" />
      </CenterBox>
    </BackgroundContainer>
  );
};

export default Loading;
